import { extractJsonObject } from "../outline/outlinePrompt.js";
import { updateSlideInDeck } from "../editor/deckEditor.js";
import { getLayerGraphic, slideTextForGraphicCompose } from "../graphic/graphicLayer.js";
import { surfBedrockChat } from "./surfBedrockChat.js";
const TEMPLATES = ["list", "process", "cycle", "pyramid", "comparison"];
function parseGraphicSpec(raw) {
    const obj = extractJsonObject(raw);
    if (!obj)
        throw new Error("Risposta AI non contiene JSON valido per il grafico.");
    const templateRaw = String(obj.template ?? "list").trim();
    const template = TEMPLATES.includes(templateRaw) ? templateRaw : "list";
    const itemsRaw = Array.isArray(obj.items) ? obj.items : [];
    const items = itemsRaw
        .map((item) => {
        if (!item || typeof item !== "object")
            return null;
        const row = item;
        const label = String(row.label ?? "").trim();
        if (!label)
            return null;
        return {
            label,
            sublabel: String(row.sublabel ?? "").trim() || undefined,
            icon: String(row.icon ?? "dot").trim() || "dot",
        };
    })
        .filter((x) => x !== null);
    if (!items.length)
        throw new Error("Il grafico AI non contiene elementi validi.");
    return { template, items };
}
export async function composeGraphicSpec(cfg, slideCopy, opts) {
    const raw = await surfBedrockChat(cfg, {
        feature: "surf.graphic.compose",
        systemText: [
            "You compose a structured SmartArt-style graphic for a presentation slide.",
            "Use ONLY facts from the slide copy. NEVER invent numeric data or statistics.",
            "Return ONLY JSON:",
            '{"template":"list"|"process"|"cycle"|"pyramid"|"comparison","items":[{"label":"...","sublabel":"...","icon":"dot"|"star"|"check"|"arrow"|"circle"|"diamond"|"bolt"|"heart"}]}',
            "Pick template by content: steps→process, pros/cons→comparison, hierarchy→pyramid, loop→cycle, else list.",
            "3-6 items with substantive labels from the copy.",
        ].join(" "),
        userText: [
            opts?.template ? `Preferred template: ${opts.template}` : "",
            "Slide copy:",
            slideCopy.slice(0, 6000),
        ]
            .filter(Boolean)
            .join("\n\n"),
        maxTokens: 2048,
    });
    return parseGraphicSpec(raw);
}
export async function composeGraphicForSlide(cfg, deck, slideId, layerId) {
    const slide = deck.slides.find((s) => s.id === slideId);
    if (!slide)
        throw new Error("Slide non trovata");
    const layer = layerId ? slide.layers.find((l) => l.id === layerId) : undefined;
    const existing = layer?.type === "graphic" ? getLayerGraphic(layer) : undefined;
    const copy = slideTextForGraphicCompose(slide);
    return composeGraphicSpec(cfg, copy, { template: existing?.template });
}
export function applyGraphicToLayer(deck, slideId, layerId, graphic) {
    return updateSlideInDeck(deck, slideId, (slide) => ({
        ...slide,
        layers: slide.layers.map((l) => l.id === layerId ? { ...l, style: { ...l.style, graphic } } : l),
    }));
}
export function slideBulletsToGraphicItems(slide) {
    return slide.layers
        .filter((l) => l.type === "text" && (l.textRole === "bullet" || l.textRole === "body"))
        .map((l) => l.content.replace(/^•\s*/, "").trim())
        .filter(Boolean)
        .map((label, i) => ({
        label,
        icon: ["dot", "star", "check", "arrow", "circle"][i % 5] ?? "dot",
    }));
}
